import { ISubscription } from '@sdk/contracts';

export const isActivityCompleted = (
  activityId: string | undefined,
  subscription: ISubscription | undefined
) => {
  return subscription?.activityTracking.find(t => t.activity === activityId)?.isCompleted;
};
